import React, { useEffect, useMemo, useRef } from "react";
import { useHistory } from "react-router";
import EditTemplateProduct from "./EditTemplateProduct";
import TemplateInstanceProvider, {
  ACTIONS,
  createInstance,
} from "../../../../Providers/TemplateInstanceProvider";
import useTemplateInstance from "../../hooks/useTemplateInstance";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { usePriceList } from "../../../providers/PriceListProvider";
import useTemplate from "../../../../hooks/useTemplate";
import { useTranslation } from "react-i18next";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";
import RecentImagesProvider from "../../Providers/RecentImagesProvider";

export default ({ orderLine }) => {
  const { currentPictureSet } = usePictureSets();

  return (
    <GreenScreenBackgroundsProvider jobUuid={currentPictureSet.job.uuid}>
      <TemplateInstanceProvider>
        <Wrapper orderLine={orderLine} />
      </TemplateInstanceProvider>
    </GreenScreenBackgroundsProvider>
  );
};

const Wrapper = ({ orderLine }) => {
  const [state, dispatch] = useTemplateInstance();
  const { getProductByUuid } = usePriceList();
  const history = useHistory();
  const { updateItem } = useShoppingCart();
  const { t } = useTranslation();

  console.log("Edit order line", orderLine);
  const [template, loading] = useTemplate(orderLine.template.uuid);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (orderLine.isUpdating || orderLine.isDeleting) {
      return;
    }
    // At this point, we should have an template update, so redirect:
    history.push("/shopping-cart/");
  }, [orderLine]);

  useEffect(() => {
    if (!template) {
      return;
    }

    console.log("Template loaded, setting instance");

    const product = getProductByUuid(orderLine.product.uuid);

    const templateInfo = orderLine.template;

    const { year } = templateInfo.data;

    const inst = createInstance(template);
    console.log("Setting resources", orderLine.template);
    const instance = {
      ...inst,
      resources: {
        ...inst.resources,
        ...templateInfo.data.userResources,
      },
    };

    console.log("Setting instance", instance);

    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: instance,
    });

    dispatch({
      type: ACTIONS.SET_PRODUCT,
      product,
    });

    dispatch({
      type: ACTIONS.SET_YEAR,
      year,
    });
  }, [orderLine, template]);

  if (!state.template) {
    return null;
  }

  const handleUpdateCart = (resources) => {
    const templateUuid = orderLine.template.uuid;
    updateItem({
      ...orderLine,
      template: {
        uuid: templateUuid,
        data: {
          year: state.year,
          userResources: resources.reduce((resources, resource) => {
            resources[resource.fullId] = resource;
            return resources;
          }, {}),
        },
      },
    });
  };

  const handleGoBack = () => {
    history.push("/shopping-cart/");
  };

  return (
    <EditTemplateProduct
      mode="update"
      handleGoBack={handleGoBack}
      updateCart={handleUpdateCart}
      cartButtonLabel={t("Update cart")}
    />
  );
};
